// extracted by mini-css-extract-plugin
export default {"component":"App_component_W8cOG","component__default":"App_component__default_n0ihR"};